import React from 'react';
import { COLORS } from '../config/colors';
import { Box, Typography, ButtonGroup, Button } from '@mui/material';

const ModeToggle = ({ mode, onModeChange, disabled }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, mt: 1 }}>
      <ButtonGroup 
        size="small"
        variant="contained" 
        aria-label="mode toggle"
        sx={{ 
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: '#2563EB',
          '& .MuiButtonGroup-grouped': {
            border: 'none',
            minWidth: '60px',
          }
        }}
      >
        <Button 
          onClick={() => onModeChange('plan')}
          sx={{ 
            backgroundColor: mode === 'plan' ? '#2563EB' : COLORS.background.secondary,
            color: mode === 'plan' ? 'white' : 'white',
            '&:hover': {
              backgroundColor: mode === 'plan' ? '#2563EB' : COLORS.background.secondary,
              opacity: 0.9
            },
            borderRadius: '16px 0 0 16px',
            px: 2,
            py: 0.5,
            fontSize: '0.75rem'
          }}
        >
          Plan
        </Button>
        <Button 
          onClick={() => onModeChange('act')}
          disabled={disabled}
          sx={{ 
            backgroundColor: mode === 'act' ? '#2563EB' : COLORS.background.secondary,
            color: mode === 'act' ? 'white' : disabled ? '#4B5563' : 'white',
            '&:hover': {
              backgroundColor: mode === 'act' ? '#2563EB' : COLORS.background.secondary,
              opacity: 0.9
            },
            borderRadius: '0 16px 16px 0',
            px: 2,
            py: 0.5,
            fontSize: '0.75rem'
          }}
        >
          Act
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default ModeToggle;
